export function getMessage (data) {
    if (typeof data === 'string') return data
    if (process.env.NODE_ENV === 'development') console.error(data)
    return data && data.data && typeof data.data === 'string' ? data.data : data.msg
}




// WEBPACK FOOTER //
// ./src/mixins/utils.js